<div class="container">
    <app-navbar></app-navbar>
    <app-shared-loading *ngIf="loading"></app-shared-loading>
    <div id="ticketDiv">
        <div class="voucherBox">
            <div class="containerLogo">
                <p class="topMsg">{{ 'payment-Receipt-Title' | translation | async }}</p>
                <img src="assets/images/payvalida.svg" alt="Payvalida, pasarela de pagos"
                    title="Payvalida, pasarela de pagos" class="voucherLogo" />
            </div>

            <div class="leftInfoVoucher">
                <fa-icon [icon]="icon" class="icon"></fa-icon>
                <h1 class="approved">
                    {{ voucherTitle | translation | async }}
                </h1>
                <h2>{{ transaction.MERCHANT_NAME }}</h2>

                <p *ngIf="inProgressOrder" class="inProgressMessage"
                    innerHTML="{{ 'inProgress-Pay-Desc' | translation | async }}">
                </p>

                <div class="leftInfoVoucher">
                    <article class="infoOrder">
                        <p> {{ 'html-Date-Title' | translation | async }} : {{ currentDate }}</p>
                        <p class="reference"> <b>{{ 'html-Reference-Title' | translation | async }}: {{
                                orderInfo.reference }}</b> </p>
                        <p>{{ 'pay-Identification-Title' | translation | async }}: {{ orderInfo.approvalNumber }}</p>
                        <p>{{ 'html-Order-Title' | translation | async }}: {{ orderInfo.orderCode }}</p>
                        <p>{{ 'transInfo-Descrip' | translation | async }} {{ transaction.ORDER_BRIEF }}</p>
                    </article>

                    <div class="containerAmount">
                        <b>{{ 'html-Total-Title' | translation | async }}:</b>
                        <b>${{ transaction.ORDER_AMOUT | number : '1.2-2' }} {{ transaction.ORDER_CURRENCY }}</b>
                    </div>
                </div>
            </div>
            <app-buttons-bar [valid]="true" (PR)="printVoucher()"></app-buttons-bar>
            <p class="voucherFooter">{{ 'no-Print-Receipt' | translation | async }}</p>
        </div>
    </div>
</div>
<app-footer></app-footer>